import Markdown from 'react-markdown';
import s from './MarkdownPreview.module.css';

/*
 * Renders trusted markdown (cabin_documents content authored by owners/admins)
 * to HTML. react-markdown does NOT pass raw HTML through by default — without
 * rehype-raw, embedded <script>/<img onerror=…> in the source are escaped, so
 * this is XSS-safe for the textarea-authored content in Iter 4+.
 */
type MarkdownPreviewProps = {
  markdown: string;
  /**
   * 'display' renders the body in the Great Vibes display script — the Om hytta
   * "handwritten letter" treatment from the Iter-4 wireframe. 'default' is the
   * normal Lato prose used everywhere else (e.g. Hytteregler from Iter 5).
   */
  variant?: 'default' | 'display';
};

export function MarkdownPreview({ markdown, variant = 'default' }: MarkdownPreviewProps) {
  const className = variant === 'display' ? `${s.prose} ${s.display}` : s.prose;
  return (
    <div className={className}>
      <Markdown>{markdown}</Markdown>
    </div>
  );
}
